import { useField } from "formik";
import { useWorkflowNames } from "../..//data/workflow";
import { Dropdown } from "../";
import { isArray, isEmpty } from "lodash";
import { checkFormValidity } from "../../../src/utils/helpers";
import React, { useEffect } from "react";
import { WorkflowErrors } from "../../contexts/WorkflowErrors";

export default function (props) {
  const [field, meta, helper] = useField(props);
  const touchedError = meta.touched && meta.error;

  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);

  useEffect(() => {
    // function to check the validity of the field
    checkFormValidity(field, meta, props, taskErrors, setTaskErrors);
  }, [field, meta, props]);

  const { data, refetch } = useWorkflowNames();
  const options = data ? (isArray(data) ? data : []) : [];

  useEffect(() => {
    // Trigger a refetch when workflowName changes
    refetch();
  }, []);

  return (
    <Dropdown
      disableClearable
      label={props.label || "Workflow Name"}
      options={options ? options : []}
      placeholder={"Select Workflow Name"}
      loading={isEmpty(options)}
      // error={touchedError}
      // helperText={touchedError}
      {...field}
      {...props}
      onChange={(e, value) => helper.setValue(value)}
    />
  );
}
